import {CatalogProductDetailRestDto} from "@/api/pharma-cpc-product-mgmt/models";
import {CatalogProductDetailRestDtoModel} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductDetailRestDtoModel";

export class CatalogProductWithImageDetailRestDtoModel {
    main_image_url: string | undefined;
    product: CatalogProductDetailRestDto;

    constructor(product: CatalogProductDetailRestDto, main_image_url: string | undefined = undefined) {
        this.main_image_url = main_image_url;
        this.product = product;
    }

    static createWithDefaults(): CatalogProductWithImageDetailRestDtoModel {
        return new CatalogProductWithImageDetailRestDtoModel(CatalogProductDetailRestDtoModel.createWithDefaults());
    }
}
